/**
 * linkedPageKindToBusinessProcess: LinkedPageKind → BusinessProcess のマッピング。
 *
 * backend `valueobject/linked_page_kind_to_business_process.go` をミラー。
 * backend 側の写像を変更した場合は本ファイルも同期すること。
 * (Sync target: go/internal/backend/domain/valueobject/linked_page_kind_to_business_process.go)
 *
 * 対象 6 kind のみ Some、それ以外は undefined (= 承認対象なし)。
 */
import { BusinessProcess } from '@ebalance/proto/bfftypes/v1/approval_flow_type_pb'
import { LinkedPageKind } from '@ebalance/proto/bffuser/v1/workflow_template_model_pb'

export function linkedPageKindToBusinessProcess(
  kind: LinkedPageKind,
): BusinessProcess | undefined {
  switch (kind) {
    case LinkedPageKind.DEMAND_FORECAST_DAILY:
      return BusinessProcess.DEMAND_FORECAST
    case LinkedPageKind.BIDDING_SPOT:
      return BusinessProcess.SPOT_BID
    case LinkedPageKind.BIDDING_INTRADAY:
      return BusinessProcess.INTRADAY_BID
    case LinkedPageKind.PLAN_PROCUREMENT:
      return BusinessProcess.PROCUREMENT_PLAN
    case LinkedPageKind.PLAN_GEN_SALES:
      return BusinessProcess.GENERATION_PLAN
    case LinkedPageKind.PLAN_DEMAND_SUPPRESSION:
      return BusinessProcess.SUPPRESSION_PLAN
    default:
      // 承認対象外の画面 (ダッシュボード / 顧客管理 / ワークフロー一覧 等)
      return undefined
  }
}
